var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.639,
    height: 49,
    viewBox: "0 0 185.639 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(23.995 0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UDT_logo_Image",
    "data-name": "UDT_logo\\xA0Image",
    transform: "translate(-23.995 -0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M369.9,31.219c-.422,2.695-.8,5.393-1.295,8.08-.153.849.245,2.119-1.44,2.079-1.544-.032-1.186-1.158-1.327-1.979a71.081,71.081,0,0,0-1.609-7.838v8.108c0,.8.322,1.758-1.17,1.717-1.3-.036-1.134-.8-1.134-1.609V26.723c0-.893.036-1.7,1.235-1.46.989.2,2.5-.828,2.719,1.3a64.824,64.824,0,0,0,1.577,8.969c.4-2.775,1-5.538,1.154-8.325.117-2.176,1.335-1.955,2.791-1.983,1.987-.036,1.206,1.4,1.206,2.252.072,4.082.024,8.168.036,12.25,0,.9.137,1.673-1.263,1.665-1.484,0-1.162-.933-1.166-1.737V31.2Z",
    transform: "translate(-216.361 -15.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M198.8,32.5c0-1.987.032-3.974,0-5.956-.024-.9.173-1.311,1.207-1.311s1.166.535,1.162,1.375V40.073c0,.7.032,1.384-1.005,1.3-.8-.064-1.709.269-2.011-1.026a64.03,64.03,0,0,0-2.791-9.154v8.7c0,.853.064,1.536-1.207,1.516s-1.17-.768-1.17-1.585V26.761c0-.712-.185-1.645,1.009-1.468.913.137,2.2-.688,2.566,1.05.438,2.067,1.07,4.1,1.609,6.141Z",
    transform: "translate(-115.366 -15.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M422.713,32.461V26.6c0-.8-.02-1.412,1.118-1.384.981,0,1.251.358,1.243,1.3-.036,4.484,0,8.973-.02,13.461,0,.643.169,1.424-.917,1.375-.9-.04-1.822.261-2.128-1.146-.611-2.815-1.416-5.57-2.148-8.353a1.013,1.013,0,0,0-.611-.668V39.99c0,.8,0,1.412-1.118,1.388-.985,0-1.255-.37-1.247-1.3.032-4.484,0-8.973,0-13.461,0-.664-.109-1.5.933-1.335.909.149,2.212-.744,2.618.969.5,2.107,1.114,4.187,1.677,6.278Z",
    transform: "translate(-249.222 -15.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M270.96,33.341c0-2.2.052-4.424-.024-6.612-.04-1.158.374-1.609,1.492-1.44a1.114,1.114,0,0,0,.2,0c5.538-.1,6.218.567,6.214,6.149,0,2.071.06,4.146-.064,6.214-.157,2.65-1.327,3.684-3.949,3.74-3.873.088-3.873.088-3.869-3.845Zm5.172-.044h0V28.872c0-.973-.648-1.142-1.488-1.182-1.026-.044-1.01.567-1.005,1.275v8.414c0,.752-.273,1.637,1.09,1.589,1.207-.04,1.432-.7,1.424-1.685-.044-1.315-.036-2.65-.036-3.986Z",
    transform: "translate(-161.971 -15.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M303.892,33.309V26.694c0-.543-.257-1.384.676-1.379,1.657,0,3.342-.3,4.971.233a3.084,3.084,0,0,1,2.128,3.1c.1,3.069.149,6.149,0,9.214-.117,2.485-1.379,3.471-3.941,3.523-3.853.08-3.853.08-3.853-3.664Zm5.172.024V29.127c0-1-.438-1.4-1.46-1.436-1.207-.048-1.05.7-1.05,1.432v8.41c0,.728-.157,1.484,1.042,1.436,1.018-.036,1.476-.426,1.468-1.428C309.052,36.137,309.064,34.733,309.064,33.334Z",
    transform: "translate(-181.655 -15.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M441.9,33.4c0-2.272.032-4.545,0-6.817,0-.925.261-1.4,1.247-1.275a2.627,2.627,0,0,0,.4,0c5.558-.117,6.262.563,6.254,6.113,0,2.136.064,4.279-.076,6.411-.169,2.51-1.367,3.519-3.9,3.579-3.905.1-3.905.1-3.905-3.8Zm2.658-.117c0,1.4-.02,2.815,0,4.207,0,.664-.294,1.528.957,1.508.969,0,1.544-.3,1.54-1.347V29.043c0-1.074-.631-1.3-1.573-1.311-1.094,0-.921.7-.925,1.347C444.554,30.483,444.558,31.886,444.558,33.286Z",
    transform: "translate(-264.178 -15.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M400.277,33.191c0,1.665.125,3.342-.028,5-.2,2.119-1.637,3.217-3.873,3.169s-3.664-1.207-3.74-3.33c-.121-3.262-.121-6.539,0-9.805.093-2.14,1.512-3.306,3.712-3.362,2.317-.048,3.74,1.078,3.929,3.334.137,1.657.028,3.33.028,5Zm-5.168-.265V37.35c0,.881.257,1.633,1.319,1.645s1.375-.648,1.375-1.581V28.787c0-.941-.382-1.564-1.408-1.544-.937,0-1.259.664-1.271,1.48C395.093,30.114,395.113,31.518,395.109,32.926Z",
    transform: "translate(-234.673 -14.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M177.474,32.408c0,1.874.064,3.752,0,5.631a3.378,3.378,0,0,1-3.547,3.547c-2.284.117-3.9-1.022-4-3.278-.173-4.022-.052-8.044-.109-12.045,0-1.066.648-.921,1.319-.977.921-.072,1.323.217,1.307,1.207-.048,3.145-.02,6.29,0,9.435v1.609c.052.841.177,1.645,1.323,1.609s1.267-.756,1.267-1.649V27.039c0-.9-.282-1.854,1.307-1.8,1.472.048,1.166.933,1.174,1.745V32.4Z",
    transform: "translate(-101.523 -15.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M346.177,40.379c.157.523.161,1.094-.8.977-.692-.084-1.581.4-1.81-.925-.141-.837.438-2.28-1.408-2.321-1.3-.032-2.011.253-2.039,1.653-.02.889-.076,1.729-1.408,1.633-.861-.064-1.207-.249-1.046-1.162.8-4.673,1.609-9.351,2.349-14.032.253-1.581,1.428-.764,2.2-.913s1.512-.048,1.685,1.09C344.613,31,345.417,35.613,346.177,40.379Zm-4.219-11.531h-.241c-.286,1.894-.567,3.793-.865,5.687-.121.768-.032,1.231.961,1.251,1.166.024,1.134-.583,1.005-1.388C342.525,32.537,342.244,30.691,341.958,28.849Z",
    transform: "translate(-201.84 -15.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M253.241,25.249c.736,0,1.472.044,2.2,0,.9-.064,1.323.185,1.311,1.207s-.306,1.359-1.263,1.243a6.7,6.7,0,0,0-.8,0c-2.252,0-3.157,1.343-2.413,3.463.31.873.989.43,1.512.531.853.161,2.091-.527,2.067,1.271-.024,1.665-1.17,1.207-1.955,1.134-1.319-.092-1.834.35-1.657,1.669a7.972,7.972,0,0,1,0,1.806c-.1,1.009.229,1.492,1.323,1.379.728-.08,1.472,0,2.2-.02,1.078-.064.917.672.949,1.335s-.133,1.182-.973,1.1h-.6c-1.782-.121-4.058.748-5.208-.366-1.074-1.038-.29-3.3-.322-5.023-.048-2.815.092-5.631-.048-8.422-.092-1.778.354-2.642,2.26-2.3A8.164,8.164,0,0,0,253.241,25.249Z",
    transform: "translate(-149.079 -15.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M230.019,34.56c0-1.806-.048-3.62,0-5.421.036-1.009-.229-1.544-1.327-1.367s-1.347-.322-1.351-1.347c0-1.13.611-1.11,1.408-1.1,1.806.024,3.62.036,5.417,0,.832-.02,1.207.217,1.207,1.122s-.133,1.5-1.207,1.319c-1.512-.265-1.56.619-1.544,1.754.044,3.479,0,6.962.036,10.457.02,1.094-.241,1.532-1.432,1.52s-1.279-.579-1.259-1.5C230.019,38.176,230.019,36.366,230.019,34.56Z",
    transform: "translate(-135.91 -15.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M220.574,33.378c0,2.268-.04,4.537,0,6.8.024.973-.33,1.263-1.275,1.259s-1.456-.169-1.44-1.3c.052-4.533.04-9.069,0-13.606,0-.973.346-1.259,1.283-1.259s1.472.169,1.432,1.3C220.518,28.837,220.574,31.11,220.574,33.378Z",
    transform: "translate(-130.242 -15.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M330.534,33.554c0,2.2-.036,4.424,0,6.6.024.949-.282,1.3-1.255,1.279s-1.476-.121-1.46-1.283q.085-6.8,0-13.606c0-1.166.539-1.259,1.468-1.279s1.267.342,1.247,1.283C330.5,28.884,330.534,31.221,330.534,33.554Z",
    transform: "translate(-195.978 -15.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M287.73,87.293V81.827c0-.294.117-.511.438-.539a.8.8,0,0,1,.8.454c.7,1.182,1.432,2.349,2.494,4.086l.209-4.589.732.032a47.129,47.129,0,0,1-.064,5.594c-.113.925-.861.5-1.231-.076a17.127,17.127,0,0,0-2.594-3.394v3.925Z",
    transform: "translate(-172.012 -48.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M372.626,84.355a2.769,2.769,0,0,1-2.815,2.976,3.051,3.051,0,0,1,.149-6.1A2.815,2.815,0,0,1,372.626,84.355Zm-.881,0c-.056-1.243-.535-2.22-1.963-2.208-1.271,0-1.882.8-1.906,2.067-.028,1.335.539,2.22,1.93,2.24C371.117,86.471,371.636,85.582,371.745,84.355Z",
    transform: "translate(-219.352 -48.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M317.439,81.31a2.818,2.818,0,0,1,2.839,3.129,2.824,2.824,0,1,1-5.631-.185A2.757,2.757,0,0,1,317.439,81.31Zm2.051,2.864c-.269-1.114-.744-2.136-2.188-2.011-1.372.125-1.906,1.05-1.83,2.361a1.85,1.85,0,0,0,2.011,2.011C318.9,86.51,319.334,85.493,319.49,84.174Z",
    transform: "translate(-188.104 -48.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M212.033,87.12c-1.91.282-4.126.724-4.424-.036-.6-1.641-.249-3.648-.173-5.5,0-.4,2.212-.4,4.074.024-.7.889-1.609.4-2.365.5-.563.06-1.022,0-1.013.8s.487.764,1.038.8a3.77,3.77,0,0,1,2.232.326c-.712.728-1.468.479-2.115.463-.824,0-1.207.161-1.17,1.09s.434.929,1.114.941A4.238,4.238,0,0,1,212.033,87.12Z",
    transform: "translate(-123.909 -48.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M237.767,83.712c-1.227-.925-1.822-2.115-3.085-1.436a2.124,2.124,0,0,0-1.046,2.011,1.988,1.988,0,0,0,1.267,2.075,1.392,1.392,0,0,0,1.922-.913c.121-.33.29-.68.7-.523.6.237.189.7.076,1a2.068,2.068,0,0,1-2.385,1.384A2.57,2.57,0,0,1,232.8,84.4c0-1.548.475-2.855,2.188-3.137C236.367,81.062,237.413,81.556,237.767,83.712Z",
    transform: "translate(-139.174 -48.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M399.652,86.815c-1.854.869-3,.539-3.744-1.082s-.173-3.692,1.359-4.255,2.847-.33,3.656,1.745c-1.5-.571-2.815-2.083-4.07-.261a2.216,2.216,0,0,0,0,2.622c.724,1.106,1.733,1.058,2.815.575A5.937,5.937,0,0,0,399.652,86.815Z",
    transform: "translate(-236.49 -48.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M265.381,87.118c-1.142-1.05.458-3.4-2.268-3.117-2.413.257-.265,2.248-1.673,2.876V80.47c.853,1.142-.1,3.149,2.28,2.855,2.047-.249.4-1.983,1.661-2.538Z",
    transform: "translate(-156.296 -48.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M423.78,81.351a8.606,8.606,0,0,1,2.546,2.381c.981-.579.74-2.28,2.506-2.542-.865,2.011-2.413,3.563-2.091,5.747,0,.1-.253.33-.4.342a.434.434,0,0,1-.458-.495C426.241,84.6,424.6,83.157,423.78,81.351Z",
    transform: "translate(-253.346 -48.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M347.562,87.022c-2.9,1.207-3.712.716-3.712-2.115V81.46c1.207.921.853,2.071.76,3.057-.161,1.737.378,2.449,2.14,2.119a.7.7,0,0,1,.812.386Z",
    transform: "translate(-205.562 -48.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M182.809,87.585a5.6,5.6,0,0,1-.269-2.843c0-1.448.29-2.972-2.079-2.96a8.848,8.848,0,0,1,4.85-.1C181.381,82.441,184.434,85.711,182.809,87.585Z",
    transform: "translate(-107.884 -48.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M403.907,90.864v-.656c1.556-2.011-1.126-.8-1.207-1.758a1.792,1.792,0,0,1,2.2-.161c.652.627.4,1.806.173,2.658S404.357,90.365,403.907,90.864Z",
    transform: "translate(-240.744 -52.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M31.373,48.984q-2.576-3.016-5.12-6.033Q13.275,27.717.308,12.458c-.366-.43-.442-.652,0-1.122Q5.231,5.963,10.106.505a1.375,1.375,0,0,1,1.158-.515H51.482a1.3,1.3,0,0,1,1.1.426q4.935,5.538,9.942,11.036c.3.334.33.511.024.873Q47.1,30.472,31.67,48.654C31.582,48.747,31.485,48.848,31.373,48.984Zm0-3.483.209-.237Q45.449,28.948,59.34,12.619c.487-.575.426-.865-.044-1.375Q55.447,7.053,51.655,2.8a1.452,1.452,0,0,0-1.186-.571q-19.112.028-38.207,0a1.359,1.359,0,0,0-1.134.5q-3.885,4.344-7.8,8.639c-.374.4-.45.635-.04,1.118q7.859,9.182,15.657,18.408C23.068,35.748,27.194,40.611,31.373,45.5Z",
    transform: "translate(-0.005 0.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M77.566,7.71q9.339,0,18.681-.032a.865.865,0,0,1,.72.31q3.672,4.175,7.372,8.329a.974.974,0,0,1,.089.229,1.544,1.544,0,0,1-.9.093c-6.033-.032-12.065-.06-18.1-.133-.672,0-.9.225-1.03.828Q81.246,32.367,78.06,47.393c-.109.511-.233,1.022-.37,1.609a1.114,1.114,0,0,1-.261-.756c.237-.225.141-.519.141-.8Q77.574,27.585,77.566,7.71Z",
    transform: "translate(-46.29 -4.582)",
    fill: "#5d9ed6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M38.093,7.676V47.424c0,.265.1.559-.141.8q-3.278-15.52-6.543-31c-.121-.567-.334-.74-.925-.74-6.338.024-12.677,0-19.059,0-.1-.205.161-.314.29-.458q3.511-3.994,7.03-7.971a1.018,1.018,0,0,1,.828-.438Q28.835,7.672,38.093,7.676Z",
    transform: "translate(-6.817 -4.549)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.7696172d819e60c6761243954bc737cc.svg";
export { ForwardRef as ReactComponent };